/**
 * Centralized dismissal reasons for the reader annotation editor so logs and
 * close paths stay aligned as the interaction model evolves.
 */
export enum ANNOTATION_EDITOR_CLOSE_REASON {
    unspecified = 'unspecified',
    postMouseUpSelectionCollapsed = 'post-mouseup-selection-collapsed',
    highlightDismissOutsideTap = 'highlight-dismiss-outside-tap',
    highlightDismissSelectionInsideAnnotationEditor = 'highlight-dismiss-selection-inside-annotation-editor',
    highlightDismissSelectionMatchesVisibleQuoteText = 'highlight-dismiss-selection-matches-visible-quote-text',
    highlightDismissMatchingVisibleHighlight = 'highlight-dismiss-matching-visible-highlight',
    highlightDismissOutsideInteractionWithoutSelection = 'highlight-dismiss-outside-interaction-without-selection',
    highlightDismissCollapsedKeyup = 'highlight-dismiss-collapsed-keyup',
    mousedownOutsideAnnotationEditor = 'mousedown-outside-annotation-editor',
}
